// src/redux/SessionUrl/sessionUrlApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// POST /public/session-url/check
export const checkSessionUrlAPI = async ({ company_session_id, email }) => {
  try {
    const response = await apiService.post(endpoints.checkSessionUrl, {
      company_session_id,
      email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// POST /public/session-url/submit
export const submitSessionUrlAPI = async ({
  company_session_id,
  name,
  email,
  phone,
  result_json,
}) => {
  try {
    const response = await apiService.post(endpoints.submitSessionUrl, {
      company_session_id,
      name,
      email,
      phone,
      result_json,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
